export default "__VITE_ASSET__wNb$2oHj__"